<template>
    <div class="header-challenge-flow">
        <div class="header-challenge-flow__headings">
            <h2>İŞLEYİŞ</h2>
            <h1>Meydan Okuma</h1>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {};
</script>

<style scoped src="@/css/components/header-challenge-flow.css"></style>